import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { Spinner } from '@trello/nachos/spinner';
import type { TestId } from '@trello/test-ids';

import * as styles from './WorkspacePageSpinner.module.less';

export const WorkspacePageSpinner: FunctionComponent<{ testId?: TestId }> = ({
  testId,
}) => {
  const { value: isM2WorkspaceNavEnabled } = useFeatureGate(
    'billplat_m2_workspace_pages',
  );

  return (
    <main
      className={cx(styles.page, {
        [styles.fullscreen]: isM2WorkspaceNavEnabled,
      })}
    >
      <Spinner centered testId={testId} />
    </main>
  );
};
